var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"403"}},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":""}},[_c('div',{staticClass:"text-md-center"},[_c('h1',[_vm._v("403")]),_c('h2',{staticClass:"my-3 headline"},[_vm._v("Sorry, access denied")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }